import { getLogger } from 'mk2/logger';
import { AppState } from 'mk2/reducers';
import * as fromEntities from 'mk2/reducers/entities';
import { denormalize, schema } from 'normalizr';
import { createSelector } from 'reselect';

const logger = getLogger('selectors');

export const getRoutingLocation = (state: AppState) => state.routing.location;

export const createDenormalizedEntitySelector = <T>(): ((state: AppState, schm: schema.Entity, id: number | string) => T) => createSelector(
    [
        (state: AppState, schm: schema.Entity, id: number | string) => state.entities,
        (state: AppState, schm: schema.Entity, id: number | string) => schm,
        (state: AppState, schm: schema.Entity, id: number | string) => id,
    ],
    (entities: fromEntities.EntitiesState, schm: schema.Entity, id: number | string) => {
        if (!entities[schm.key]) {
            return null;
        }
        return denormalize(id, schm, entities);
    },
);

export const createDenormalizedEntitiesSelector = <T>(): ((state: AppState, schm: schema.Entity, ids: number[] | string[]) => T[]) => createSelector(
    [
        (state: AppState, schm: schema.Entity, ids: number[] | string[]) => state.entities,
        (state: AppState, schm: schema.Entity, ids: number[] | string[]) => schm,
        (state: AppState, schm: schema.Entity, ids: number[] | string[]) => ids,
    ],
    (entities: fromEntities.EntitiesState, schm: schema.Entity, ids: number[] | string[]) => {
        if (!entities[schm.key]) {
            return []; // FIXME to avoid re-render, it should cache the value, not return new array
        }
        return denormalize(ids, [schm], entities);
    },
);

export const getDenormalizedEntity: <T>(state: AppState, schm: schema.Entity, id: number | string) => T = <T>(state: AppState, schm: schema.Entity, id: number | string) => {
    if (process.env.NODE_ENV === 'development') {
        logger.warn(`DEPRECATED getDenormalizedEntity(): Do not use this function directly, because it's caching only last value! Use createDenormalizedEntitySelector() to create own instance of a selector function`);
    }
    return createDenormalizedEntitySelector<T>()(state, schm, id);
};
export const getDenormalizedEntities: <T>(state: AppState, schm: schema.Entity, ids: number[] | string[]) => T[] = <T>(state: AppState, schm: schema.Entity, ids: number[] | string[]) => {
    if (process.env.NODE_ENV === 'development') {
        logger.warn(`DEPRECATED getDenormalizedEntities(): Do not use this function directly, because it's caching only last value! Use createDenormalizedEntitiesSelector() to create own instance of a selector function`);
    }
    return createDenormalizedEntitiesSelector<T>()(state, schm, ids);
};
